import React from 'react';
import { View, StyleSheet } from 'react-native';
import { colors } from '../../utils/colors';
import { spacing } from '../../utils/theme';

interface SkeletonProps {
  width?: number | string;
  height?: number;
  borderRadius?: number;
  style?: any;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = 20,
  borderRadius: radius = 4,
  style,
}) => {
  return (
    <View
      style={[
        styles.skeleton,
        {
          width,
          height,
          borderRadius: radius,
        },
        style,
      ]}
    />
  );
};

export const PostCardSkeleton: React.FC = () => {
  return (
    <View style={styles.postCard}>
      <View style={styles.avatarContainer}>
        <Skeleton width={40} height={40} borderRadius={20} />
      </View>

      <View style={styles.content}>
        <View style={styles.header}>
          <Skeleton width={120} height={16} style={{ marginRight: spacing.sm }} />
          <Skeleton width={80} height={14} />
        </View>

        <Skeleton width="100%" height={14} style={{ marginBottom: spacing.xs }} />
        <Skeleton width="90%" height={14} style={{ marginBottom: spacing.xs }} />
        <Skeleton width="70%" height={14} style={{ marginBottom: spacing.sm }} />

        <View style={styles.actions}>
          <Skeleton width={60} height={16} style={{ marginRight: spacing.lg }} />
          <Skeleton width={60} height={16} style={{ marginRight: spacing.lg }} />
          <Skeleton width={60} height={16} />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  skeleton: {
    backgroundColor: colors.backgroundSecondary,
    overflow: 'hidden',
  },
  postCard: {
    flexDirection: 'row',
    padding: spacing.md,
    backgroundColor: colors.background,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  avatarContainer: {
    marginRight: spacing.md,
  },
  content: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.sm,
  },
  actions: {
    flexDirection: 'row',
    marginTop: spacing.sm,
  },
});
